const styles = {
  card: {
    flex: 1,
  },
};

export default styles;
